import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import CodeValidation from './components/CodeValidation';
import FormularioSeleccion from './components/FormularioSeleccion';

// Configurar axios globalmente con el token de API
axios.defaults.headers.common["X-API-KEY"] = '#$"%&MiTokenUltra#$SecretoLouisTechTecnology123$';
axios.defaults.baseURL = 'https://postula.doms.pe';

function App() {
  const [isCodeValid, setIsCodeValid] = useState(false);
  const [campaignData, setCampaignData] = useState(null);
  const [campaignCode, setCampaignCode] = useState('');

  const handleCodeValidation = (isValid, data, code) => {
    setIsCodeValid(isValid);
    setCampaignData(data);
    setCampaignCode(code);
  };

  const handleBackToValidation = () => {
    setIsCodeValid(false);
    setCampaignData(null);
    setCampaignCode('');
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-6xl">
        {!isCodeValid ? (
          <CodeValidation onValidation={handleCodeValidation} />
        ) : (
          <FormularioSeleccion 
            campaignData={campaignData}
            campaignCode={campaignCode}
            onBack={handleBackToValidation}
          />
        )}
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;
